import { map } from 'rxjs'
import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { NotificationPreference } from '@models/notification.model'
import { NotificationApiBaseService } from '@services/api/notification-api-base.service'

@Injectable({
	providedIn: 'root'
})
export class NotificationService extends NotificationApiBaseService {
	private readonly source: string

	constructor(override http: HttpClient) {
		super(http)
		this.source = ''
	}

	save(entity: NotificationPreference) {
		return this.post<NotificationPreference, Response>(`${this.source}/preferences`, entity)
	}

	update(id: string, entity: NotificationPreference) {
		return this.put<NotificationPreference, Response>(`${this.source}/preferences/${id}`, entity)
	}

	index() {
		return this.get<{ content: NotificationPreference[] }>(`${this.source}/preferences`).pipe(
			map(response => response.content)
		)
	}
}
